var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle, _path33, _path34, _path35, _circle2, _path36, _path37, _circle3, _path38, _circle4, _circle5, _circle6, _circle7, _path39, _circle8, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStockMarketHoroscope = function SvgStockMarketHoroscope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    "aria-hidden": "true",
    clipRule: "evenodd",
    viewBox: "0 0 278 213"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#def7ec",
    d: "M18.123 31.324h238.059v160.604H18.123z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "m72.72 55.911-.288.391-.432-.224c-.906-.469-2.002-.747-3.19-.747-3.282 0-5.695 2.064-5.695 4.337 0 1.389.874 2.679 2.332 3.496l.384.215-.112.426a3 3 0 0 0-.098.77c0 1.706 1.417 3.11 3.189 3.11.779 0 1.489-.271 2.042-.72l.419-.341.363.401c1.013 1.121 2.72 1.887 4.694 1.887 3.283 0 5.695-2.064 5.695-4.337v-.57h.57c2.465 0 4.442-1.953 4.442-4.337s-1.977-4.337-4.442-4.337c-.765 0-1.483.188-2.11.519l-.408.216-.296-.355a4.47 4.47 0 0 0-3.451-1.607 4.47 4.47 0 0 0-3.608 1.807z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M18.123 31.324h238.059v160.604H18.123z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M158.572 153.613c13.724-5.757-8.683-15.592-21.602-19.789 1.695-2.999 11.447-7.197 47.026 0 35.58 7.196 45.978 17.431 44.062 24.565-1.271 2.099-7.663 3.244-12.133 5.838-2.554 1.483-6.822 8.576-8.94 12.324H56.281c3.601-2.999 13.851-9.985 26.05-13.943 15.248-4.947 59.087-1.799 76.241-8.995z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M75.646 94.54h112.765v42.144H75.646z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#18191b",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M75.646 100.235h112.765v1.139H75.646z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffced0",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M68.811 100.235h121.877v-4.344l-34.243-18.34-14.975 7.798-27.192-14.729-45.467 23.944z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f97386",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M143.987 105.93h37.589v30.754h-37.589z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M156.517 119.599v-9.112h-5.696m20.503 0v9.112h5.695m-26.198 10.251h26.198m-26.198-2.278h26.198"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#f97386",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M103.552 109.917h12.529v20.503h-12.529z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M88.175 129.85h44.422v6.834H88.175z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M90.453 134.406h38.727v3.417H90.453z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M84.188 109.917h10.251v11.39H84.188z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#f97386",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M80.771 109.917h3.417v11.39h-3.417zm13.669 0h3.417v11.39H94.44zm26.197 0h3.417v11.39h-3.417zm15.946 0H140v11.39h-3.417z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M124.054 109.917h12.529v11.39h-12.529zM85.897 85.428h7.973m33.031-1.139h10.252m-14.807-4.556h6.834m18.224 2.278h5.695m14.808 9.112h13.669M80.201 88.845h12.53m86.567 6.834h11.39m-121.877 0h34.171"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "m198.144 79.242.294-.434.457.257a3.6 3.6 0 0 0 1.759.448c1.819 0 3.133-1.239 3.133-2.584 0-.825-.477-1.593-1.277-2.081l-.354-.216.097-.403a2 2 0 0 0 .053-.454c0-1.027-.773-1.797-1.652-1.797-.391 0-.753.148-1.041.403l-.44.389-.375-.452c-.555-.667-1.493-1.128-2.586-1.128-1.819 0-3.132 1.239-3.132 2.585v.569h-.57c-1.287 0-2.392 1.123-2.392 2.585s1.105 2.584 2.392 2.584a2.24 2.24 0 0 0 1.12-.3l.433-.249.304.397c.445.583 1.111.941 1.845.941.783 0 1.49-.408 1.932-1.06z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca15",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 1.14,
    d: "M214.036 169.935c-6.091 0-8.076-2.117-8.307-2.89v-33.412c0-.619 1.662-2.426 8.307-2.426s7.845 1.807 7.614 2.426v33.412c0 .773-1.523 2.89-7.614 2.89zm20.503-2.848c-6.092 0-8.076-2.437-8.307-3.656v-52.649c0-.975 1.662-2.925 8.307-2.925s7.845 1.95 7.614 2.925v52.649c0 1.219-1.523 3.656-7.614 3.656z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca15",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 1.14,
    d: "M227.372 172.782c-6.092 0-7.743-1.982-7.974-2.404v-18.225c0-.337 1.329-2.151 7.974-2.151s8.178 1.814 7.947 2.151v18.225c0 .422-1.856 2.404-7.947 2.404z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca15",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 1.14,
    d: "M227.372 172.782c-6.092 0-7.743-1.982-7.974-2.404v-18.225c0-.337 1.329-2.151 7.974-2.151s8.178 1.814 7.947 2.151v18.225c0 .422-1.856 2.404-7.947 2.404z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.14,
    d: "M205.73 133.486c-.19 1.139 1.139 3.417 7.973 3.417s8.163-2.278 7.973-3.417m-2.261 18.794c-.189 1.139 1.139 3.417 7.974 3.417 6.834 0 8.163-2.278 7.973-3.417m-9.113-42.145c-.189 1.139 1.139 3.417 7.974 3.417 6.834 0 8.163-2.278 7.973-3.417"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.14,
    d: "M226.249 127.221c-.189 1.139 1.139 3.417 7.974 3.417m-7.974-1.139c-.189 1.139 1.139 3.417 7.974 3.417m-28.477 14.808c-.189 1.139 1.139 3.417 7.974 3.417m-7.974 3.417c-.189 1.139 1.139 3.417 7.974 3.417m-7.974-1.139c-.189 1.139 1.139 3.417 7.974 3.417m20.503-36.449c6.834 0 8.163-2.278 7.973-3.417m-7.973-4.557c6.834 0 8.163-2.278 7.973-3.417m-7.973 13.669c6.834 0 8.163-2.278 7.973-3.417m-7.973 19.363c6.834 0 8.163-2.278 7.973-3.417m-14.807 19.364c6.834 0 8.163-2.278 7.973-3.417m-7.973 10.251c6.834 0 8.163-2.278 7.973-3.417m-21.659-20.503c6.834 0 8.163-2.278 7.973-3.417m5.713 29.615c6.834 0 8.163-2.278 7.973-3.417m-21.659-20.503c6.834 0 8.163-2.278 7.973-3.417"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3a008",
    fillRule: "nonzero",
    d: "m206.363 124.818 1.099-2.034c1.238-1.639 3.364-.732 7.905 1.905 2.348 1.363 4.241 3.504 5.318 6.587a.5.5 0 0 1-.158.329l-.891 1.848c-.959.134-3.747-.018-7.229-1.697s-5.48-5.325-6.044-6.938"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.14,
    d: "m207.462 122.784-1.099 2.034c.564 1.613 2.561 5.259 6.044 6.938s6.27 1.831 7.229 1.697l1.049-2.177m-13.223-8.492c1.238-1.639 3.364-.732 7.905 1.905 2.348 1.363 4.241 3.504 5.318 6.587m-13.223-8.492c.752 2.151 3.192 5.681 5.506 7.125 2.475 1.545 7.605 2.773 7.717 1.367"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.14,
    d: "M205.812 121.302c-.502-.487-1.084-.9-1.63-1.337m2.934-.228c-.131-.578-.182-1.168-.358-1.735-.075-.239-.18-.465-.229-.71m13.663 8.673c.107-.612.033-1.238.033-1.859m.815 3.196c.542-.106 1.061-.297 1.598-.424"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca15",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 1.14,
    d: "M60.538 169.935c6.092 0 8.076-2.117 8.307-2.89v-33.412c0-.619-1.661-2.426-8.307-2.426-6.645 0-7.844 1.807-7.614 2.426v33.412c0 .773 1.523 2.89 7.614 2.89zm-20.502-2.848c6.091 0 8.075-2.437 8.306-3.656v-52.649c0-.975-1.661-2.925-8.306-2.925-6.646 0-7.845 1.95-7.615 2.925v52.649c0 1.219 1.523 3.656 7.615 3.656z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca15",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 1.14,
    d: "M47.203 172.782c6.091 0 7.742-1.982 7.973-2.404v-18.225c0-.337-1.328-2.151-7.973-2.151s-8.178 1.814-7.948 2.151v18.225c0 .422 1.856 2.404 7.948 2.404z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca15",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 1.14,
    d: "M47.203 172.782c6.091 0 7.742-1.982 7.973-2.404v-18.225c0-.337-1.328-2.151-7.973-2.151s-8.178 1.814-7.948 2.151v18.225c0 .422 1.856 2.404 7.948 2.404z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.14,
    d: "M68.844 133.486c.19 1.139-1.139 3.417-7.973 3.417s-8.163-2.278-7.973-3.417m2.261 18.794c.19 1.139-1.139 3.417-7.973 3.417-6.835 0-8.163-2.278-7.974-3.417m9.113-42.145c.19 1.139-1.139 3.417-7.973 3.417-6.835 0-8.164-2.278-7.974-3.417"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.14,
    d: "M48.325 127.221c.19 1.139-1.139 3.417-7.973 3.417m7.973-1.139c.19 1.139-1.139 3.417-7.973 3.417m28.476 14.808c.19 1.139-1.139 3.417-7.973 3.417m7.973 3.417c.19 1.139-1.139 3.417-7.973 3.417m7.973-1.139c.19 1.139-1.139 3.417-7.973 3.417m-20.503-36.449c-6.835 0-8.164-2.278-7.974-3.417m7.974-4.557c-6.835 0-8.164-2.278-7.974-3.417m7.974 13.669c-6.835 0-8.164-2.278-7.974-3.417m7.974 19.363c-6.835 0-8.164-2.278-7.974-3.417m14.808 19.364c-6.835 0-8.164-2.278-7.974-3.417m7.974 10.251c-6.835 0-8.164-2.278-7.974-3.417m21.659-20.503c-6.834 0-8.163-2.278-7.973-3.417m-5.712 29.615c-6.835 0-8.164-2.278-7.974-3.417m21.659-20.503c-6.834 0-8.163-2.278-7.973-3.417"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3a008",
    fillRule: "nonzero",
    d: "m68.211 124.818-1.099-2.034c-1.237-1.639-3.364-.732-7.905 1.905-2.348 1.363-4.241 3.504-5.318 6.587q.017.198.158.329l.891 1.848c.959.134 3.747-.018 7.229-1.697s5.48-5.325 6.044-6.938"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.14,
    d: "m67.112 122.784 1.099 2.034c-.564 1.613-2.561 5.259-6.044 6.938s-6.27 1.831-7.229 1.697l-1.049-2.177m13.223-8.492c-1.237-1.639-3.364-.732-7.905 1.905-2.348 1.363-4.241 3.504-5.318 6.587m13.223-8.492c-.751 2.151-3.192 5.681-5.506 7.125-2.475 1.545-7.605 2.773-7.717 1.367"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.14,
    d: "M68.762 121.302c.502-.487 1.085-.9 1.631-1.337m-2.935-.228c.131-.578.183-1.168.359-1.735.074-.239.179-.465.228-.71m-13.663 8.673c-.107-.612-.033-1.238-.033-1.859m-.815 3.196c-.542-.106-1.061-.297-1.598-.424"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M54.003 162.882h43.284v45.562H54.003z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#f97386",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M54.003 162.882h43.284v13.669H54.003z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.645,
    cy: 191.358,
    r: 9.682,
    fill: "#18191b",
    stroke: "#18191b",
    strokeWidth: 1.14
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e7eb",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "m74.287 181.805-.151.024c-.923.154-2.146.461-3.362 1.069-1.214.607-2.411 1.508-3.305 2.85-.892 1.338-1.506 3.147-1.506 5.61s.614 4.273 1.506 5.611c.894 1.341 2.091 2.243 3.305 2.85 1.216.608 2.439.915 3.362 1.069l.151.024a21 21 0 0 1-1.406-2.007c-1.167-1.9-2.362-4.569-2.362-7.547s1.195-5.646 2.362-7.547c.499-.812.998-1.492 1.406-2.006z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M115.511 162.882h43.283v45.562h-43.283z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#f97386",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M115.511 162.882h43.283v13.669h-43.283z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.153,
    cy: 191.358,
    r: 9.682,
    fill: "#e5e7eb",
    stroke: "#18191b",
    strokeWidth: 1.14
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M177.019 162.882h43.283v45.562h-43.283z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#f97386",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M177.019 162.882h43.283v13.669h-43.283z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.661,
    cy: 191.358,
    r: 9.682,
    fill: "#18191b",
    stroke: "#18191b",
    strokeWidth: 1.14
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e7eb",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "m200.018 181.805.151.024c.924.154 2.147.461 3.363 1.069 1.214.607 2.41 1.508 3.304 2.85.892 1.338 1.506 3.147 1.506 5.61s-.614 4.273-1.506 5.611c-.894 1.341-2.091 2.243-3.304 2.85-1.216.608-2.439.915-3.363 1.069l-.151.024c.409-.514.907-1.195 1.406-2.007 1.167-1.9 2.362-4.569 2.362-7.547s-1.195-5.646-2.362-7.547a20 20 0 0 0-1.406-2.006z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 2.848,
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.14,
    transform: "matrix(1 0 0 -1 5.594 46.7)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 3.987,
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.14,
    transform: "matrix(1 0 0 -1 10.15 153.77)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 1.709,
    fill: "none",
    stroke: "#18191b",
    strokeWidth: 1.14,
    transform: "matrix(1 0 0 -1 15.845 17.085)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.123,
    cy: 90.554,
    r: 17.086,
    fill: "#84e1bc",
    stroke: "#18191b",
    strokeWidth: 1.14
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M12.997 81.726v3.738a6.8 6.8 0 0 0-1.708 4.52c0 1.733.645 3.316 1.708 4.52v3.738c0 .788.636 1.424 1.424 1.424h7.404c.788 0 1.424-.636 1.424-1.424v-3.738a6.8 6.8 0 0 0 1.708-4.52 6.8 6.8 0 0 0-1.708-4.52v-3.738c0-.788-.636-1.424-1.424-1.424h-7.404c-.788 0-1.424.636-1.424 1.424zm5.553 4.983v3.458l.235.171 1.351.984-.503.692-1.937-1.411v-3.894z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.527,
    cy: 43.283,
    r: 37.019,
    fill: "#7ec4f6",
    stroke: "#18191b",
    strokeWidth: 1.14
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M134.875 7.404v51.257H41.474V7.404z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8b4d9",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M54.102 34.279a1.137 1.137 0 0 0 1.04 1.601h2.277v3.987a2.85 2.85 0 0 0 2.848 2.848h3.987v3.417h12.529v-9.146l.191-.17a9.64 9.64 0 0 0 3.226-7.2c0-5.345-4.337-9.682-9.682-9.682h-3.956a10.54 10.54 0 0 0-8.613 4.47c-.29.413-.609 1.064-.946 1.882a52 52 0 0 0-1.006 2.719c-.152.44-.303.887-.454 1.331-.506 1.493-1 2.95-1.441 3.943zm10.721-2.96q.002-.141.015-.279H62.83a3.134 3.134 0 0 1-.224-6.257 3.1 3.1 0 0 1 1.69-1.521 3.1 3.1 0 0 1 2.176.003c.235-.265.515-.49.827-.663l.262.473-.262-.473a3.12 3.12 0 0 1 3.848.664c.343-.13.707-.198 1.077-.2h.003a3.13 3.13 0 0 1 3.088 2.606 3.127 3.127 0 0 1 .891 5.873 3.133 3.133 0 0 1-3.125 2.912h-.005a3 3 0 0 1-.28-.016v2.579H68.24v-2.579q-.14.015-.279.016h-.006c-.83 0-1.627-.33-2.214-.918a3.13 3.13 0 0 1-.918-2.215z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4c6fc",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "m120.505 24.235.034-.169.122-.121c.223-.223.26-.372.26-.452v-.712a.553.553 0 0 0-.569-.569h-14.523c-2.106 0-3.702 1.596-3.702 3.701v14.238c0 2.106 1.596 3.702 3.702 3.702h14.523c.241 0 .368-.07.434-.135.065-.066.135-.193.135-.434V28.476a.65.65 0 0 0-.046-.279.13.13 0 0 0-.066-.066l-.234-.117-.064-.254c-.091-.363-.124-1.072-.124-1.722 0-.661.035-1.387.118-1.803zm-14.676-.315h13.241v3.987h-13.241c-.989 0-1.993-.788-1.993-1.994 0-.556.188-1.064.558-1.435.37-.37.878-.558 1.435-.558z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#18191b",
    fillRule: "nonzero",
    d: "M91.876 37.588v-2.562h2.563a.57.57 0 0 0 .57-.57v-.569a.57.57 0 0 0-.57-.57h-2.563v-2.563a.57.57 0 0 0-.569-.569h-.57a.57.57 0 0 0-.569.569v2.563h-2.563a.57.57 0 0 0-.569.57v.569c0 .315.255.57.569.57h2.563v2.562c0 .315.255.57.569.57h.57a.57.57 0 0 0 .569-.57"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.14,
    d: "M227.706 29.615c-3.116-3.554-6.357-6.816-10.251-9.112m21.642 4.556c1.274-3.428 1.134-6.791 1.134-10.252m10.255 14.808c2.543-2.612 5.627-4.828 7.978-7.594.32-.376.699-1.308 1.135-1.518m-34.171 20.502h-10.251m37.588 2.278c3.424-.217 6.847-.43 10.251-1.139m-36.449 10.252c-2.607 1.268-5.168 2.727-7.973 3.417m31.892-2.278c1.225 1.089 2.457 1.824 3.889 2.535.25.124.835.23 1.051.402.236.188.514.304.756.48"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#18191b",
    strokeWidth: 1.14,
    d: "M249.182 45.401c.833-2.232 1.305-4.405 1.305-6.042 0-5.381-5.1-9.744-11.391-9.744-6.29 0-11.39 4.363-11.39 9.744 0 1.637.472 3.81 1.305 6.042h-.003l4.393 12.69h11.879l3.905-12.69z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e7eb",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 1.14,
    d: "M233.401 58.091h11.391v2.278h-11.391z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#d1d4dc",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 1.14,
    d: "M245.32 62.647h-11.155s-.764-.614-.764-1.139c0-.524.764-1.139.764-1.139h11.155s.611.642.611 1.139-.611 1.139-.611 1.139z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#d1d4dc",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 1.14,
    d: "M245.32 64.925h-11.155s-.764-.614-.764-1.139c0-.524.764-1.139.764-1.139h11.155s.611.642.611 1.139c0 .498-.611 1.139-.611 1.139z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e7eb",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 1.14,
    d: "M239.587 70.62c-4.416 0-5.047-5.695-5.047-5.695h10.251s-.777 5.695-5.204 5.695z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.14,
    d: "M238.269 58.091c.109-.436.095-1.561.104-2.002.016-.803.001-1.592-.104-2.389-.148-1.13-.186-2.233-.333-3.36-.095-.725-.046-1.339-.414-1.973-.162-.279-.876-.708-1.219-.446-.367.282-.653.417-.621.892.021.303.993.622 1.265.694 1.114.296 2.231-.069 3.346-.069.659 0 .93-.044 1.495-.288.382-.164.75-.676.725-1.05-.018-.255-1.013-.179-1.242-.179-.493 0-.647.356-.805.714-.171.386.027 1.05.057 1.427.053.666.127 1.356.127 2.022 0 .974.31 1.932.31 2.885 0 1.029.104 2.08.104 3.122"
  })));
};
export default SvgStockMarketHoroscope;